<ng-container>
  <label>{{ label }}</label>
  <mat-form-field id="select" appearance="fill">
    <mat-select
      [attr.name]="name"
      [value]="field.value"
      (selectionChange)="value = $event.value"
      [disabled]="disabled"
      [multiple]="multiple"
      [placeholder]="placeholder"
      [panelClass]="searchable ? 'input-select-search-panel' : ''"
      (openedChange)="onOpenedChange($event)"
    >
      <div *ngIf="searchable" class="select-search-header">
        <input
          #searchInput
          type="text"
          class="select-search-input"
          [placeholder]="'Search' | translate"
          (input)="onSearchInput($event)"
          (keydown)="onSearchKeydown($event)"
          (click)="$event.stopPropagation()"
        />
        <div *ngIf="multiple" class="select-search-actions">
          <button type="button" class="select-search-action" (click)="selectAllVisible()">
            {{ 'SelectAll' | translate }}
          </button>
          <button type="button" class="select-search-action" (click)="clearSelection()">
            {{ 'Clear' | translate }}
          </button>
        </div>
      </div>
      <mat-option
        *ngFor="let option of options"
        [value]="option.value"
        [class.select-option-hidden]="searchable && !isOptionVisible(option)"
      >
        {{ optionText(option.text) }}
      </mat-option>
      <div *ngIf="searchable && searchText && !hasVisibleOptions" class="select-search-no-results">
        {{ 'NoResultsFound' | translate }}
      </div>
    </mat-select>
    <div *ngIf="showSuccessIcon" class="success-icon" matSuffix>
      <mat-icon>check</mat-icon>
    </div>
    <!-- <mat-icon id="icon" matSuffix>expand_more</mat-icon> -->
  </mat-form-field>
</ng-container>
